import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { Table } from "banafo-design-system";
const ApiKeysTable = ({ apiKeys, renderItem }) => {
    const { t } = useTranslation();
    return (_jsxs(Table, { responsive: true, hover: true, children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", {}), _jsx("th", { children: t('API.key.prefix_') }), _jsx("th", { children: t('Created.At_') }), _jsx("th", { className: "text-center", children: t('Actions_') })] }) }), _jsx("tbody", { children: apiKeys.map((apiKey) => renderItem(apiKey)) })] }));
};
export default ApiKeysTable;
